import * as React from 'react'
import Navbar from '../Navbar'
import Footer from '../Footer'
import Cookiebanner from '../Cookiebanner'

export const BACKGROUND_VARIANTS = {
    LIGHT: 'light',
    DARK: 'dark',
    COLOR: 'color',
}

const MainLayout = ({ children, bgVariant }) => {
    return (
        <>
            <Navbar bgVariant={bgVariant} />
            <Cookiebanner />
            {children}
            <Footer />
        </>
    )
}

export default MainLayout
